import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'affiliationStatus'
})
export class AffiliationStatusPipe implements PipeTransform {

  affiliationStatus = '';

  transform(value: any): any {
    switch (value) {
      case 'VIGEN': {
        this.affiliationStatus = 'Vigente';
        break;
      }
      case 'RETIR': {
        this.affiliationStatus = 'Retirado';
        break;
      }
    }

    return this.affiliationStatus;
  }

}
